var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDownloadYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#f28705;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1236 -932)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32,
    transform: "translate(1236 932)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1244.651 940.651)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.639,15v3.253a1.627,1.627,0,0,1-1.627,1.627H4.627A1.627,1.627,0,0,1,3,18.253V15",
    transform: "translate(-3 -5.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7,10l4.066,4.066L15.133,10",
    transform: "translate(-3.747 -4.307)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 9.76,
    transform: "translate(7.32 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadYellow);
export default __webpack_public_path__ + "static/media/Icon_Download_Yellow.65ee6b587df769cab92c2943c8d7156e.svg";
export { ForwardRef as ReactComponent };